import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ordersAPI, subscriptionsAPI } from '../services/api';
import './Dashboard.css';

function CustomerDashboard() {
  const [orders, setOrders] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [ordersRes, subsRes] = await Promise.all([
        ordersAPI.getAll(),
        subscriptionsAPI.getAll(),
      ]);
      setOrders(ordersRes.data.slice(0, 5)); // Latest 5 orders
      setSubscriptions(subsRes.data.filter(s => s.status === 'active'));
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="page dashboard-page">
      <h1 className="page-title">Customer Dashboard</h1>

      <div className="dashboard-grid">
        <div className="card">
          <h2>Active Subscriptions</h2>
          {subscriptions.length === 0 ? (
            <p>No active subscriptions</p>
          ) : (
            <ul className="subscription-list">
              {subscriptions.map((sub) => (
                <li key={sub.id}>
                  {sub.product?.name} - {sub.quantity} bags ({sub.frequency})
                  <br />
                  <small>Next delivery: {new Date(sub.next_delivery_date).toLocaleDateString()}</small>
                </li>
              ))}
            </ul>
          )}
          <Link to="/subscriptions" className="btn btn-primary">
            Manage Subscriptions
          </Link>
        </div>

        <div className="card">
          <h2>Recent Orders</h2>
          {orders.length === 0 ? (
            <p>No orders yet</p>
          ) : (
            <ul className="order-list">
              {orders.map((order) => (
                <li key={order.id}>
                  {order.order_number} - ${order.total_amount}
                  <br />
                  <span className={`status-badge status-${order.status}`}>
                    {order.status}
                  </span>
                </li>
              ))}
            </ul>
          )}
          <Link to="/orders" className="btn btn-primary">
            View All Orders
          </Link>
        </div>

        <div className="card">
          <h2>Quick Order</h2>
          <p>Place a new one-time order</p>
          <Link to="/products" className="btn btn-success">
            Order Now
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CustomerDashboard;
